import cn from "classnames";
import { IconX } from "./icons";

/**
 * DeploymentLabel
 *
 * Small tag chip used to mark deployments in a comparison view, e.g.
 * "Current" vs "Selected to restore" in the rollback modal. May expand to
 * include other colors if needed, but red should be avoided.
 */
export type DeploymentLabelVariant = "default" | "success";

const deploymentLabelStyles: Record<DeploymentLabelVariant, string> = {
  default: "bg-black-50 border-black-200 text-black-500",
  success: "bg-green-100 border-green-200 text-forest",
};

export const DeploymentLabel = ({
  children,
  className = "",
  variant = "default",
  onRemove,
}: {
  children: React.ReactNode;
  className?: string;
  variant?: DeploymentLabelVariant;
  onRemove?: () => void;
}) => (
  <div
    className={cn(
      "rounded border h-[20px] px-2 py-1 flex gap-1.5 justify-center items-center w-fit box-border",
      "font-mono text-xs leading-none uppercase",
      deploymentLabelStyles[variant],
      className,
    )}
  >
    <span>{children}</span>
    {onRemove ? (
      <button
        type="button"
        aria-label="Remove"
        onClick={onRemove}
        className="flex items-center justify-center"
      >
        <IconX variant="sm" className="w-3 h-3" />
      </button>
    ) : null}
  </div>
);
